import { MegaphoneIcon } from 'lucide-react';
import { Badge } from '@tinct/web-components';
import type { LandingPageVariationAxis } from '@tinct/core-api-models';

type CampaignAxisBadgeProps = {
  axis: LandingPageVariationAxis | null | undefined;
  className?: string;
};

/**
 * Marks ads campaigns (variants declined per matched ads campaign — Google
 * Ads or LinkedIn Ads, the axis covers both providers). Company-list is the
 * overwhelming default, so it renders nothing for it — only the exception
 * gets a chip.
 */
export function CampaignAxisBadge({ axis, className }: CampaignAxisBadgeProps) {
  if (axis !== 'adword') return null;
  return (
    <Badge
      variant="secondary"
      className={`gap-1.5 ${className ?? ''}`.trim()}
      title="Ads campaign (Google Ads / LinkedIn Ads)"
    >
      <MegaphoneIcon className="size-3" />
      Ads campaign
    </Badge>
  );
}
